type UnknownRecord = Record<string, unknown>;

const asRecord = (value: unknown): UnknownRecord | undefined =>
  typeof value === 'object' && value !== null
    ? (value as UnknownRecord)
    : undefined;

const asStatus = (value: unknown): number | undefined =>
  typeof value === 'number' && Number.isInteger(value) ? value : undefined;

const asUrl = (value: unknown): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;

export const getRequestStatus = (error: unknown): number | undefined => {
  const source = asRecord(error);
  const response = asRecord(source?.response);

  return (
    asStatus(response?.status) ??
    asStatus(source?.status) ??
    asStatus(source?.statusCode)
  );
};

export const getRequestUrl = (error: unknown): string | undefined => {
  const source = asRecord(error);
  const response = asRecord(source?.response);
  const request = asRecord(source?.request);
  const config = asRecord(source?.config);
  const responseConfig = asRecord(response?.config);

  return (
    asUrl(config?.url) ??
    asUrl(responseConfig?.url) ??
    asUrl(response?.url) ??
    asUrl(request?.responseURL)
  );
};

export const isUnauthorizedRequest = (error: unknown): boolean =>
  getRequestStatus(error) === 401;
